import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextDisease } from "./TextDisease";
import { SourcesDisease } from "./SourcesDisease";

export default function Disease() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>     

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Heart Diseases Panel' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Heart Diseases'

        content={<TextDisease />}

        sources={<SourcesDisease />}

/>

</>
)}